import { ActualIssueProductsApi, Api, HttpClient } from '../../../api'
import {
  ActualIssueProductOptions,
  ActualIssueProductsService,
  AddActualIssueProductOpts,
  GroupedByMEActualIssueProduct,
} from './actualIssueProducts'
import { Context, Id, PaginatedResult } from '../../../common'

function mapDtoToActualIssueProduct(dto: Api.GroupedActualIssueProduct): GroupedByMEActualIssueProduct {
  return {
    municipalEntityId: dto.municipalEntityId,
    values: dto.values,
  }
}

export class RemoteActualIssueProductsService implements ActualIssueProductsService {
  private api: ActualIssueProductsApi

  constructor(httpClient: HttpClient) {
    this.api = new ActualIssueProductsApi(httpClient, undefined, '')
  }

  async formReport(
    ctx: Context,
    opts?: ActualIssueProductOptions | undefined,
  ): Promise<PaginatedResult<GroupedByMEActualIssueProduct>> {
    const result = await this.api.actualIssueProductsFormReport(ctx, {
      ids: opts?.filter?.ids,
      dateFrom: opts?.filter?.dateFrom?.toString(),
      dateTo: opts?.filter?.dateTo?.toString(),
      municipalEntityId: opts?.filter?.municipalEntityId,
      aFrom: opts?.paging?.from,
      count: opts?.paging?.count,
    })

    return {
      ...result.body,
      items: result.body.items.map(mapDtoToActualIssueProduct),
    }
  }
  async add(ctx: Context, opts: AddActualIssueProductOpts): Promise<Id> {
    const result = await this.api.actualIssueProductsAdd(ctx, {
      ...opts,
      dataEntryDate: opts.dataEntryDate.toISOString(),
    })

    return result.body.id
  }
}
